import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '../../environments/environment';

export interface UsuarioPayload {
  dadosBasicos: {
    nome: string;
    cpfCnpj: string;
    idTipoUsuario: number;
  };
  autenticacao: {
    email: string;
    senha: string;
  };
  contato: {
    telefoneCelular: string;
    contatoEmergencia: string;
    telefoneEmergencia: string;
  };
  endereco: {
    cep: string;
    logradouro: string;
    numero: string;
    cidade: string;
    bairro: string;
    estado: string;
    complemento: string;
  };
  dadosPessoais: {
    fotoBase64?: string;
    fotoMimeType?: string;
    cargo: string;
    salarioBase: number;
    dataAdmissao: string;
    genero: string;
    idSetor: number;
    idUnidade: number;
    idJornadaTrabalho: number;
    idFuncao: number;
  };
  usuarioResponsavelPeloCadastro: string;
}

export interface fotoBase64 {
  fotoBase64: string;
}

export interface ApiResponse {
  codigo: number;
  listaMensagem: string[];
}

export interface EnderecoViaCep {
  cep: string;
  logradouro: string;
  bairro: string;
  localidade: string;
  uf: string;
}

@Injectable({
  providedIn: 'root'
})

export class UsuarioService {
  // private apiUrl = 'https://localhost:7103/api/Usuario'; 


  //cadastrarUsuario(usuarioData: UsuarioPayload): Observable<ApiResponse> {
    //return this.http.post<ApiResponse>(this.apiUrl, usuarioData);
  //}
  private baseUrl = environment.apiUrlExbeOn; 
  constructor(private http: HttpClient) { }

  cadastrarUsuario(usuarioData: UsuarioPayload): Observable<ApiResponse> {    
    return this.http.post<ApiResponse>(`${this.baseUrl}/Usuario/criar`, usuarioData);
  }

   buscarCep(cep: string): Observable<EnderecoViaCep> {
    return this.http.get<EnderecoViaCep>(`${this.baseUrl}/Cep/${cep}`);
  }

   obterFotoUsuario() {
    return this.http.get<fotoBase64>(`${this.baseUrl}/Usuario/foto`);
  }

}